import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Card from '../components/Card';
import Carousel from '../components/Carousel'
import CategoryCard from '../components/CategoryCard';
import Footer from '../components/Footer';
import Header from '../components/Header'
import banner1 from '../img/banner-1.jpg'
import banner2 from '../img/banner-2.jpg'
import groceryData from '../groceryData/grocery-data';
import Countdown from './Countdown';


export default function Home() {

  const [search, setsearch] = useState("");

  const onChange = (e) => {
    setsearch(e.target.value)
    console.log(e.target.value);
  }


  return (
    <>
      <div className='body-section'>
        <Header input=<input className="form-control me-2" type="search" value={search} onChange={onChange} placeholder="Search" aria-label="Search" /> />
        <Carousel />
        <div className='banner-container'>
          <div className="banner">
            <img src={banner1} alt="" />
            <div className="content">
              <h3>special offer</h3>
              <p>upto 45% off</p>
              <Link to="#" className="btn all-btn">check out</Link>
            </div>
          </div>
          <div className="banner">
            <img src={banner2} alt="" />
            <div className="content">
              <h3>limited offer</h3>
              <p>upto 50% off</p>
              <Link to="#" className="btn all-btn">check out</Link>
            </div>
          </div>
        </div>
        <h1 className='heading'>SHOP BY CATEGORY</h1>
        <div className='row'>
          <div className='col-12 col-lg-3'>
            <CategoryCard />
          </div>
          <div className='col-12 col-lg-3'>
            <CategoryCard />
          </div>
          <div className='col-12 col-lg-3'>
            <CategoryCard />
          </div>
          <div className='col-12 col-lg-3'>
            <CategoryCard />
          </div>
        </div>
        <h1 className='heading pb-2'>LATEST PRODUCTS</h1>
        <div className='row'>
          {groceryData.filter((data) => {
            if (search === "") {
              return true;
            } else if (data.title && data.title.toLowerCase().includes(search.toLowerCase())) {
              return true;
            }
            return false;
          })
            .map(data => {
              return (
                <div className='col-lg-4'>
                  <div>
                    <Card cardData={data} />
                  </div>
                </div>
              );
            })}
          {groceryData.filter((data) => {
            if (search === "") {
              return false;
            } else if (data.title && data.title.toLowerCase().includes(search.toLowerCase())) {
              return false;
            }
            return true;
          }).length === groceryData.length &&
            <div className='col-lg-12'>
              <p style={{ fontSize: "2rem", textAlign: "center" }}>No results found.</p>
            </div>
          }
        </div>
        </div>


        <div className='container-fluid' id='deal'>
          <div className='row deal-row'>
            <div className=' deal-title col-12 col-lg-4'>
              <h3>deal of the day</h3>
              <Countdown />
              <Link to="#" className="btn all-btn">Check The Deal</Link>
            </div>

          </div>
        </div>
        <div />
        <Footer />
      </>
    
  )
}
